export const dhcTenant = {
  tenant: 'dhc',
  branding: {
    appName: 'DHC',
    shortName: 'DHC',
    logoSrc: '/static/images/Logo_8.png',
    primaryColor: '#1aa8d6',
    basePaths: {
      patient: '/lk_patient',
      staff: '/lk_doctor',
    },
  },
  clinic: {
    legalName: 'ООО «ДИ ЭЙЧ ЦЕНТР»',
    legalDetails: 'Dental Health Centre · Башня «Федерация Запад», 46 этаж',
    address: 'г. Москва, Пресненская набережная, 12',
    workHours: 'Пн–Сб 09:00 – 21:00',
    phone: '+7 (495) 021-94-04',
    phoneTel: '+74950219404',
    email: 'info@dhcentre.ru',
    website: 'https://dhcentre.ru',
    websiteLabel: 'dhcentre.ru',
    whatsappUrl: 'https://wa.me/79167481724',
    whatsappLabel: '+7 916 748-17-24',
    telegramUrl: 'https://t.me/DentalHealthCentree',
    telegramLabel: '@DentalHealthCentree',
    telegramNotifyUrl: 'https://t.me/dhc_notify_bot',
    telegramNotifyLabel: '@dhc_notify_bot',
    maxBotUrl: 'https://max.ru/id7715438229_bot',
    maxBotLabel: 'id7715438229_bot',
    vkUrl: 'https://vk.com/dhcentre',
    youtubeUrl: 'https://www.youtube.com/@DentalHealthCentre',
    publicLogoUrl: 'https://dhcentre.ru/uploads/logo_up.png',
    publicAccentColor: '#1aa8d6',
    patientPortalUrl: 'https://my.dhcentre.ru/lk_patient/',
    patientPortalLabel: 'my.dhcentre.ru/lk_patient',
  },
  capabilities: {
    supportsChat: true,
    supportsMessages: true,
    supportsCommunicationPreferences: true,
    supportsGiftCertificates: true,
    supportsCorporatePrograms: true,
    supportsOnlineAppointments: true,
    supportsVerificationWorker: false,
    supportsPlansMis: false,
    supportsDmsGuide: true,
    supportsYandexSplit: false,
    supportsInstallments: true,
    supportsQuestionnaires: true,
    supportsGuestCatalog: false,
    supportsPromotions: true,
    supportsContentLibrary: true,
    supportsReviews: true,
    supportsActivityFeed: true,
    supportsBusinessLeads: true,
    supportsStaffPayments: true,
    supportsDiagnocat: true,
    supportsStaffPromotions: true,
    supportsStaffContent: true,
    supportsStaffAnalytics: true,
    supportsPatientDrilldown: true,
  },
} as const
